function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_13769_15550)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 14H11.4V21.6H5.4C4.632 21.6 4 20.968 4 20.2V14Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 14V20.2C20 20.968 19.368 21.6 18.6 21.6H12.6V14H20Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.40002 9.4V11.4C2.40002 12.168 3.03202 12.8 3.80002 12.8H4.00002H11.4V11.6V8H3.80002C3.03202 8 2.40002 8.632 2.40002 9.4Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.2 8H12.6V11.6V12.8H20H20.2C20.968 12.8 21.6 12.168 21.6 11.4V9.4C21.6 8.632 20.968 8 20.2 8Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0001 8.83448C11.8257 8.83448 11.6593 8.75848 11.5465 8.62648C11.4321 8.49448 11.3817 8.31928 11.4065 8.14648C11.7025 6.14648 13.2649 2.36328 17.0633 2.36328C19.2313 2.36408 20.0001 3.53528 20.0001 4.53848C20.0001 6.32168 17.5177 8.83448 12.0001 8.83448ZM17.0633 3.56408C14.1977 3.56408 13.1097 6.28808 12.7489 7.61688C15.0097 7.51128 16.4353 6.93928 17.2561 6.45208C18.3945 5.77608 18.8001 5.02008 18.8001 4.53768C18.8001 3.81928 17.9033 3.56408 17.0633 3.56408Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0008 8.83368C6.48325 8.83368 4.00085 6.32088 4.00085 4.53768C4.00085 3.53448 4.77045 2.36328 6.93845 2.36328C10.736 2.36328 12.2984 6.14648 12.5944 8.14648C12.6192 8.31928 12.5688 8.49448 12.4544 8.62648C12.3416 8.75768 12.1752 8.83368 12.0008 8.83368ZM6.93845 3.56328C6.09845 3.56328 5.20085 3.81928 5.20085 4.53768C5.20085 5.55928 6.98725 7.42088 11.2512 7.61688C10.8912 6.28728 9.80325 3.56328 6.93845 3.56328Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_13769_15550"
}, /*#__PURE__*/React.createElement("rect", {
  width: 19.2,
  height: 19.2,
  fill: "white",
  transform: "translate(2.40002 2.39844)"
})));

var SvgReward = function SvgReward(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReward, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reward.2ffd1b6e.svg";
export { ForwardRef as ReactComponent };